import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './authAxios'; // enregistre les intercepteurs d'authentification globaux (Lot F p2a)
import './versionWatch'; // recharge auto quand une nouvelle version est déployée
import App from './App';
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from 'redux-persist/integration/react'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
  <PersistGate loading={null} persistor={persistor}>
    <App />
  </PersistGate>
</Provider>,
);